import React from "react";
import { PageWrapper, PageInner, PageTitle, PageTitleRow, PageTitleText, PageTitleActions, Subtitle } from "./styled";
import H2 from "components/typography/H2";

interface PageProps {
  children?: React.ReactNode;
  title?: string;
  subtitle?: string;
  backAction?: React.ReactNode;
  /**
   * Optional primary action rendered inline with the page title,
   * right-aligned. Use for the module-level "+ New X" action that
   * every top-level product surface (RFQs, Quotes, Invoices, POs,
   * Maintenance) needs. Keeps the shared header shape consistent
   * across modules rather than every page inventing its own
   * button-row layout below the title.
   */
  titleAction?: React.ReactNode;
  $noPadding?: boolean;
}

const Page: React.FC<PageProps> = ({ children, title, subtitle, backAction, titleAction, $noPadding }) => {

  return (
    <PageWrapper $noPadding={$noPadding}>
      <PageInner>
        {backAction}
        {(title || subtitle || titleAction) && (
          <PageTitle>
            <PageTitleRow>
              <PageTitleText>
                <H2 marginBottom="0px">{title}</H2>
                <Subtitle>{subtitle}</Subtitle>
              </PageTitleText>
              {titleAction && <PageTitleActions>{titleAction}</PageTitleActions>}
            </PageTitleRow>
          </PageTitle>
        )}
        {children}
      </PageInner>
    </PageWrapper>
  )
}

export default Page;
